import { TABLA_CAMIONES_SIN_CUPO } from '../../../../../../config/tables'
import { COLUMNS_CAMIONES_SIN_CUPO } from './constantesCamionesSinCupo'
import { toast } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../../config/settings'
import FechasCupo from '../../../../../../models/cupo/fechasCupo'
import SinCupo from '../../../../../../models/camiones/sin_cupo'
import { CEREALES } from '../../../../../../config/cereales'

export function parseData (fEmision, data) {
  const parsedData = []
  if (data && data.filas_procesadas > 0) {
    data.filas.map(async (entry) => {
      let arribo
      console.log(entry.fechaCupoDate, fEmision, entry.fechaCupoDate <= fEmision)
      if (entry.fechaCupoDate >= fEmision) {
        arribo = 'Adelantado'
      } else {
        arribo = 'Vencido'
      }

      return parsedData.push({ ...entry, arribo: arribo })
    })
  }
  return parsedData
}

export function actualizarDatosParaMuiTable (filtroInicial = null) {
  return dispatch => {
    Promise.all([
      FechasCupo.obtenerFechaDeEmisionDefault(),
      SinCupo.getSinCupo()
    ])
      .then(([fechaEmision, d]) => {
        const data = parseData(fechaEmision.fechaDeEmisionDefault, d)

        const customToolbar = null
        const textRowCount = 'Cantidad de camiones sin cupo: '

        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_CAMIONES_SIN_CUPO,
            data: data,
            title: `Camiones con cupo no vigente`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px',
              showRowCount: true,
              textRowCount,
              filtroInicial,
              download: false
            }
          },
          id: TABLA_CAMIONES_SIN_CUPO
        })
      })
  }
}

export function ingresarCPASinCupoTodos () {
  return (dispatch) => {
    const promesas = []
    toast.info('Procesando camiones sin cupo para ingresar')

    CEREALES.map((c) => {
      return promesas.push(SinCupo.ingresarSinCupoPorCereal(c))
    })

    Promise.all(promesas)
      .then((result) => {
        if (!result.error) {
          toast.success('Todos los camiones sin cupo fueron ingresados correctamente')
          dispatch(actualizarDatosParaMuiTable())
        } else {
          toast.error('Error al intentar ingresar todos los camiones sin cupo')
        }
      })
      .catch((e) => {
        toast.error('Error al intentar ingresar todos los camiones sin cupo')
        console.log(e)
      })
  }
}

export function ingresarCPASinCupoPorCereal (cereal, filtroInicial) {
  return (dispatch) => {
    toast.info('Procesando ingreso de cartas de porte')
    return SinCupo.ingresarSinCupoPorCereal(cereal)
      .then((result) => {
        if (!result.error) {
          toast.success(`Las cartas de porte de ${cereal} fueron ingresadas correctamente.`, { autoClose: INTERVALO_CORTO })
          dispatch(actualizarDatosParaMuiTable(filtroInicial))
        } else {
          toast.error('No se pudo realizar el ingreso de las cartas de porte', { autoClose: false })
        }
      })
      .catch((e) => {
        console.log(e)
        toast.error('No se pudo realizar el ingreso de las cartas de porte automotor', { autoClose: false })
      })
  }
}

export function ingresarCPASinCupo (numero) {
  return (dispatch) => {
    dispatch({ type: 'INGRESAR_CPA_SIN_CUPO' })
    toast.info(`Procesando ingreso`, { autoClose: INTERVALO_CORTO })
    return SinCupo.ingresarSinCupo(numero)
      .then((result) => {
        if (!result.error) {
          toast.success(`La carta de porte ${numero} fue ingresada correctamente.`, { autoClose: INTERVALO_CORTO })
          dispatch(actualizarDatosParaMuiTable())
        } else {
          toast.error('No se pudo ingresar la carta de porte automotor', { autoClose: false })
        }
      })
      .catch((e) => {
        console.log(e)
        toast.error('No se pudo ingresar la carta de porte automotor', { autoClose: false })
      })
  }
}
